import type { CareerCenter } from "@/modules/careerCenter/types"
import type { StaticImageData } from "next/image"
import type { FunctionComponent, HTMLAttributes } from "react"

import { clsx } from "clsx"
import Image from "next/image"

import { Avatar } from "@jobteaser/spark/components/Avatar"
import { Text } from "@jobteaser/spark/components/Text"

import styles from "./SchoolBadge.module.css"

type BadgeProps = HTMLAttributes<HTMLDivElement> & {
  label: string
  schoolLogo: CareerCenter["logo"] | StaticImageData // will be removed soon once we stop using fake data
  schoolName: CareerCenter["shortName"]
}

export const SchoolBadge: FunctionComponent<BadgeProps> = ({ label, schoolLogo, schoolName, ...props }) => {
  return (
    <div {...props} className={clsx(styles.main, props.className)}>
      {schoolLogo && (
        <Avatar className={styles.avatar} size={24}>
          <Image
            alt={schoolName ? `Logo ${schoolName}` : ""}
            className={styles.logo}
            height={24}
            priority
            src={schoolLogo}
            width={24}
          />
        </Avatar>
      )}
      <Text variant="body1" weight="regular">
        {label}
      </Text>
    </div>
  )
}
